import React from "react";
import MapViewer from "../components/MapViewer";
import MapSelector from "../components/MapSelector";
import FloorSelector from "../components/FloorSelector";
import FloorLegend from "../components/FloorLegend";
import GeoLocator from "../components/GeoLocator";

export default function App() {

  const [mapIndex, setMapIndex] = React.useState(0);
  const [floorIndex, setfloorIndex] = React.useState(0);

  const floorHandler = value => {
      setfloorIndex(value);
      return;
    };
 
  function handleClick(index){
    setfloorIndex(0);
    setMapIndex(index);
  }

  React.useEffect(() => {
    document.title = "R84 Mappa Interattiva"
  }, []);
 

  return (
    <div className="flex flex-col items-center">
      <div className="absolute h-full w-full z-0 justify-center">
        <MapViewer mapIndex={mapIndex} floorIndex={floorIndex}/>
      </div>
      <div className="absolute bottom-20 z-10 right-10 sm:max-md:right-20">
        <MapSelector handleClick={handleClick} selectedIndex={mapIndex}/>
      </div>
      <div className="absolute bottom-2 z-10 leading-[10px]">
        <p className="text-[9px] font-zion text-center"> Copyright © 2023 by <a className="hover:underline" href="https://r84.it" target="_blank" rel="noreferrer">Associazione R84</a> - All rights reserved<br/>~<br/>info@r84.it</p>
      </div>
      <div className="absolute bottom-10 left-20">
        <FloorSelector floorHandler={floorHandler} mapIndex={mapIndex} floorIndex={floorIndex}/>
      </div>
      <div className="absolute left-5 top-[20%]">
        <FloorLegend mapIndex={mapIndex} floorIndex={floorIndex} />
      </div>
      <GeoLocator />
    </div>
  );
}
